













import Vue from 'vue';
export default Vue.extend({
    props: {
        id: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
        cols: {
            type: Number,
            default: 30,
        },
        rows: {
            type: Number,
            default: 10,
        },
        placeholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        resize: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
});
